import { render, staticRenderFns } from "./rifinitura.vue?vue&type=template&id=a2155214&"
import script from "./rifinitura.vue?vue&type=script&lang=js&"
export * from "./rifinitura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports